import { AbstractBlock } from '../AbstractBlock';

import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';

const COLOUR = 'COLOUR';
const t = block_translation;
export class BlockElement extends AbstractBlock {
  static COLOR_FIELD = COLOUR;
  /**
   * @override AbstractBlock
   * @param {} dom
   */
  toXmlFromSubBlockCustom(dom: HTMLElement): void {
    dom.appendChild(ShapeSettings.getColorInputValueXML());
  }

  defineBlock(block: BlockType): void {
    // ブロックの属性をセット
    ShapeSettings.setElementShape(block);
    ColorSettings.setObjectColor(block);

    ShapeSettings.setTitleField(block, this.title);
    ShapeSettings.setIdField(block);

    block.appendDummyInput().appendField(t.to('位置', 'position') + ':');
    ShapeSettings.setVR3Fields(block, 'position', 0, 1, 0);
    block.appendDummyInput().appendField(t.to('色', 'color') + ':');
    block.appendValueInput(COLOUR).setCheck('Colour');
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    let attribute = CodeSetting.getSubAttributeCode(block);
    const color = CodeSetting.getColorInputValue(block);
    const id = CodeSetting.getFieldValue(block, 'id');

    attribute += `
		entity.setAttribute("id", "${id}");
		// entity.setAttribute("color", "${color}");
		${CodeSetting.getVR3FieldValues(block, 'position')}
		`;

    attribute += CodeSetting.getAttributeCode('geometry', `primitive:${this.name_for_code};`);
    attribute += CodeSetting.getAttributeCode('material', `color:${color};`);
    const str = CodeSetting.getElementCode(`a-${this.name_for_code}`, attribute, block.id, '');
    return str;
  }
}
